/**
 *  @fileOverview Navigation module
 *
 *  @author       Aaron Chapman, edits by Chris Hill
 *
 */

function NavigationModule (disableBodyScroll, enableBodyScroll, Utilities) {
  /**
   * Define the top level vars
   */
  const body = document.querySelector('body')
  const hamburger = document.querySelector('.siteHeader__hamburger')
  const siteNavigation = document.querySelector('.siteNav')
  const siteNavigationButtons = document.querySelectorAll('.siteNav__button')
  const contextualButtons = document.querySelectorAll('.siteNav__contextualButton')

  /**
   * @description Initialises navigation.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.initNavigation = function () {
    /**
     * Add event listeners for open button and escape key stroke
     */
    hamburger.addEventListener('click', hamburgerExpand)
    body.addEventListener('keydown', doClose)

    /**
     * Loop through menu items and add event listeners to toggle nav
     */
    Array.from(siteNavigationButtons).forEach(siteNavigationButton => {
      siteNavigationButton.addEventListener('click', toggleNavigation)
    })

    /**
     * Loop through menu items and add event listeners to toggle contextual nav
     */
    Array.from(contextualButtons).forEach(contextualButton => {
      contextualButton.addEventListener('click', toggleContextual)
    })

    /**
     * Check for current page section and open that part of the menu
     */
    const url = document.location.href
    const list = document.querySelectorAll('.siteNav__primaryItem')

    // Create a map of all possible top level links
    let mapItems = {
      study: null,
      research: null,
      industry: null,
      alumni: null,
      about: null
    }

    // Loop through all top level nav items and assign them to the correct map item
    list.forEach(item => {
      if (item.innerHTML.includes('Study')) {
        mapItems.study = item
      }
      if (item.innerHTML.includes('Research')) {
        mapItems.research = item
      }
      if (item.innerHTML.includes('Industry')) {
        mapItems.industry = item
      }
      if (item.innerHTML.includes('Alumni')) {
        mapItems.alumni = item
      }
      if (item.innerHTML.includes('About')) {
        mapItems.about = item
      }
    })

    // Check current page and if the corresponding map item exists, open the correct menu item
    if (url.includes('/future-students/') && mapItems.study !== null) {
      openOnItit(mapItems.study)
    } else if (url.includes('/degrees/') && mapItems.study !== null) {
      openOnItit(mapItems.study)
    } else if (url.includes('/research/') && mapItems.research !== null) {
      openOnItit(mapItems.research)
    } else if (url.includes('/industry/') && mapItems.industry !== null) {
      openOnItit(mapItems.industry)
    } else if (url.includes('/alumni/') && mapItems.alumni !== null) {
      openOnItit(mapItems.alumni)
    } else if (url.includes('/about-ecu/') && mapItems.about !== null) {
      openOnItit(mapItems.about)
    }

    /**
     * Check for Google tag manager var to determine if page is postgrad, then add toggle-2 to links
     */
    const l = window.dataLayer
    if (l !== undefined) {
      l.forEach(layer => {
        if (layer.hasOwnProperty('ECU')) {
          if (layer.ECU.hasOwnProperty('studyDetails')) {
            if (layer.ECU.studyDetails.hasOwnProperty('studyLevel')) {
              if (layer.ECU.studyDetails.studyLevel === 'Postgraduate') {
                let links = document.querySelectorAll('.siteNav__contextualInner > li > a')

                links.forEach((link, index) => {
                  if (index < 4) {
                    link.href += '#toggle-2'
                  }
                })

                /**
                 * Add toggle-2 to apply buttons in head and menu
                 */
                let apply1 = document.querySelectorAll('.siteHeader__inner > a')[1]
                let apply2 = document.querySelectorAll('.siteNav__buttonWrapper > a')[0]

                apply1.href += '#toggle-2'
                apply2.href += '#toggle-2'
              }
            }
          }
        }
      })
    }
  }

  /**
   * @description Opens the specified pimary list item.
   *
   * @param {Object} item - The primary list item to be expanded.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  let openOnItit = function (item) {
    item.dataset.toggle = 'open'
    item.querySelector('.siteNav__secondary').classList.add('siteNav__secondary--open')
    const btn = item.querySelector('.siteNav__button')
    toggleIcon(btn)
  }

  /**
   * @description Opens and closes navigation panel.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  let hamburgerExpand = function () {
    hamburger.classList.toggle('siteHeader__hamburger--active')
    siteNavigation.classList.toggle('siteNav--open')
    body.classList.toggle('menu-lock')

    /**
     * Stop page scroll if menu open
     */
    if (siteNavigation.classList.contains('siteNav--open')) {
      disableBodyScroll(siteNavigation)
      if (window.hj) {
        // HotJar active fire trigger
        window.hj('trigger', 'hamburger_open')
      }
    } else {
      enableBodyScroll(siteNavigation)
    }
  }

  /**
   * @description Close menu only if exc key pressed and overlay already open.
   *
   * @param {Object} e - Key click event object.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  let doClose = function (e) {
    if (e.which === 27 && siteNavigation.classList.contains('siteNav--open')) {
      hamburgerExpand()
    }
  }

  /**
   * @description Toggles the +/- symbol and the aria label.
   *
   * @param {Object} item - The menu item button element that was pressed.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  let toggleIcon = function (item) {
    // This currently just substitutes +/- but we should look to animate
    const span = item.querySelector('span')
    let label = item.getAttribute('aria-label')

    /**
     * Check if button is currently set to open or not
     */
    if (span.innerHTML === '+') {
      span.innerHTML = '-'

      if (label.indexOf('closed') > -1) {
        label = label.split('closed')[0] + 'open'
      } else {
        label = label.split('closed')[0] + 'closed'
      }
    } else {
      span.innerHTML = '+'

      if (label.indexOf('open') > -1) {
        label = label.split('open')[0] + 'closed'
      } else {
        label = label.split('open')[0] + 'open'
      }
    }

    item.setAttribute('aria-label', label)
  }

  /**
   * @description Opens and closes contextual menu items.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  let toggleContextual = function () {
    let contextualInner = document.querySelector('.siteNav__contextualInner')
    contextualInner.classList.toggle('siteNav__contextualInner--open')

    toggleIcon(this)
  }

  /**
   * @description Toggles the menuitem +/- and classes. Calls open close functions based on data attribute.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  let toggleNavigation = function () {
    toggleIcon(this)

    let listItem = this.closest('li')

    /**
     * Find all siblings of current item
     */
    let sibs = Utilities.getSiblings(listItem)

    sibs.forEach(sib => {
      /**
       * Set aria label of btn to closed
       */
      const sibbtn = sib.querySelector('.siteNav__button')
      if (typeof sibbtn !== 'undefined' && sibbtn !== null) {
        let label = sibbtn.getAttribute('aria-label')
        if (label.indexOf('open') > -1) {
          label = label.split('open')[0] + 'closed'
          sibbtn.setAttribute('aria-label', label)
        }
      }

      /**
       * Set span to +
       */
      const sibspan = sib.querySelector('.siteNav__button > span')
      if (typeof sibspan !== 'undefined' && sibspan !== null) {
        sibspan.innerHTML = '+'
      }

      sib.dataset.toggle = 'closed'

      /**
       * Get the child UL of the current list item if it exists
       */
      let childUL = sib.querySelector('ul')

      if (childUL !== null) {
        /**
         * Get the class name of the childUL element and remove the open class
         */
        let className = childUL.classList.item(0)
        childUL.classList.remove(className + '--open')
      }
    })

    /**
     * Toggle the data between open and closed
     */
    listItem.dataset.toggle = listItem.dataset.toggle === 'closed' ? 'open' : 'closed'

    openCloseNavigation(listItem)
  }

  /**
   * @description Opens and closes the navigation lists.
   *
   * @param {Object} element - The nav button that was clicked on.
   * @example
   * //
   * @returns {boolean} // null.
   */
  let openCloseNavigation = function (element) {
    /**
     * Determine if menu is opening or closing
     */
    const isOpen = element.dataset.toggle === 'open'

    let childNav = element.querySelector('ul')

    if (typeof childNav !== 'undefined' && childNav !== null) {
      let childNavClass = childNav.classList.item(0)
      let parentClass = element.parentElement.classList.item(0)
      let parentClassTail = parentClass.split('__').pop()

      /**
       * Add or remove open class from list.
       */
      if (isOpen) {
        childNav.classList.add(childNavClass + '--open')
      } else {
        childNav.classList.remove(childNavClass + '--open')
      }

      /**
       * Only apply to menu items secondary and below
       */
      switch (parentClassTail) {
        case 'secondary':
        case 'tertiary':
        case 'quaternary':
          let headingItem = element.querySelector('span')
          let headingItemClass = headingItem.classList.item(0)

          let otherItems = Utilities.getSiblings(element)

          /**
           * Loop through siblings of element and add or remove hidden class to header span
           */
          Array.from(otherItems).forEach(sibling => {
            if (sibling.dataset.toggle === 'closed') {
              let siblingHeader = sibling.querySelector('span')

              if (typeof siblingHeader !== 'undefined' && siblingHeader !== null) {
                let siblingClass = siblingHeader.classList.item(0)
                if (isOpen) {
                  siblingHeader.classList.add(siblingClass + '--hidden')
                } else {
                  siblingHeader.classList.remove(siblingClass + '--hidden')
                }
              }
            }
          })

          /**
           * Make visible menu items header larger on open or small on close
           */
          if (isOpen) {
            headingItem.classList.add(headingItemClass + '--large')
          } else {
            headingItem.classList.remove(headingItemClass + '--large')
          }

          /**
           * Add Remove margin class to secondary level ul
           */
          if (headingItem.classList.contains('siteNav__secondaryHeading')) {
            if (isOpen) {
              headingItem.closest('ul').classList.add('siteNav__secondary--nomargin')
            } else {
              headingItem.closest('ul').classList.remove('siteNav__secondary--nomargin')
            }
          }

          /**
           * Look back up 2 levels to UL to see top level of Nav tree
           */
          let topNavigation = element.parentElement.parentElement.parentElement
          let topNavClass = topNavigation.classList.item(0)
          let topNavItems = topNavigation.querySelectorAll('.' + topNavClass + '> li')

          /**
           * Loop through sibling list items of parent
           */
          Array.from(topNavItems).forEach(topNavLi => {
            let headItem = topNavLi.querySelector('span')
            let headClass = headItem.classList.item(0)

            /**
             * If opening add clss of hidden to parents siblings
             */
            if (isOpen) {
              headItem.classList.add(headClass + '--hidden')
            } else {
              /**
               * If closing check that it is currently open if below secondary level and remove hidden if so
               */
              if (topNavLi.dataset.toggle === 'open' || parentClassTail === 'secondary') {
                headItem.classList.remove(headClass + '--hidden')
              }
            }
          })
          break
        default:
          // We don't need to show anything
          break
      }
    }
  }
}

module.exports = NavigationModule
